/* Evira presentation helpers. No cart, checkout, analytics or catalogue mutations. */
(() => {
  if (window.eviraPresentationLoaded) return;
  window.eviraPresentationLoaded = true;
  const responsive = window.matchMedia('(min-width: 990px)');
  const disclosures = new Set();
  let headerObserver;

  const initialise = (root) => {
    root.querySelectorAll('.rte p').forEach((paragraph) => {
      // Hide visual spacer paragraphs only; keep all text, media and the stored HTML intact.
      const isSpacer = !paragraph.textContent.replace(/[\s\u00a0\u200b-\u200f\ufeff]/g, '') &&
        !paragraph.querySelector('img, video, audio, iframe, svg, canvas, picture, object, embed, input, button, select, textarea, a, table');
      paragraph.classList.toggle('evira-empty-paragraph', isSpacer);
    });
    root.querySelectorAll('[data-evira-filters]').forEach((details) => {
      if (disclosures.has(details)) return;
      disclosures.add(details);
      details.open = responsive.matches || details.dataset.hasActiveFilters === 'true';
    });
  };
  const trackHeader = () => {
    headerObserver?.disconnect();
    const header = document.querySelector('.header--sticky');
    if (!header || !window.ResizeObserver) return;
    const update = () => {
      document.documentElement.style.setProperty('--evira-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
      document.dispatchEvent(new Event('evira:header-resize'));
    };
    headerObserver = new ResizeObserver(update);
    headerObserver.observe(header);
    update();
  };
  responsive.addEventListener('change', () => disclosures.forEach((details) => {
    if (!details.isConnected) { disclosures.delete(details); return; }
    details.open = responsive.matches || details.dataset.hasActiveFilters === 'true';
  }));
  initialise(document);
  trackHeader();
  document.addEventListener('shopify:section:load', (event) => { initialise(event.target); trackHeader(); });
  document.addEventListener('shopify:section:unload', () => {
    disclosures.forEach((details) => { if (!details.isConnected) disclosures.delete(details); });
  });
})();
